<template>
    <div class="row finish-investment" v-if="finshedLoading">
        <!-- MODAL -->
        <modal v-if="showModal" @close="showModal = false">
            <div slot="header">
                <div class="row">
                    <div class="col-12">
                        <div class="tit_page">
                            <h2>
                                Pagamento
                            </h2>
                            <div class="cliearfix"></div>
                            <hr class="divider" />
                        </div>
                    </div>
                </div>
            </div>
            <div slot="body">
                <div class="row">
                    <div class="col-12">
                        <div class="bordered">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col" class="align-middle text-center" width="70">
                                            Score
                                        </th>
                                        <th scope="col" class="align-middle text-center" width="120">
                                            ID
                                        </th>
                                        <th scope="col" class="align-middle">
                                            Tomador
                                        </th>
                                        <th scope="col" class="align-middle text-center" width="150">
                                            Rendimento
                                        </th>
                                        <th scope="col" class="align-middle text-center">
                                            Valor do investimento
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-if="solicitacao != null"
                                        :class="this.ScoreClass(this.score)"
                                        class="rating-aa"
                                    >
                                        <td class="rating align-middle text-center">
                                            <span class="circle side-circle"></span> {{score}}
                                        </td>
                                        <td class="align-middle text-center">
                                            {{idOportunidade}}
                                        </td>
                                        <td class="align-middle">
                                            {{NomeTomador}}
                                        </td>
                                        <td class="align-middle text-center">
                                            {{Rendimento}}% a.a
                                        </td>
                                        <td class="align-middle text-center">
                                            {{formatCurrency(this.reserva.Valor)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="col-12 col-lg-offset-5 col-lg-10">
                            <div class="td-total">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <td class="align-middle">
                                                Total à Pagar:
                                            </td>
                                            <td class="align-middle text-right">
                                                {{ValorBoleto}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
      <!-- :::::::::::::::::: -->

        <div class="col-12">
            <div class="tit_page">
                <h1>
                    Pagamento
                </h1>
                <div class="clearfix"></div>
                <hr class="divider">
            </div>
        </div>

        <div class="col-12">
            <div class="row">
                <div class="white col-12 col-lg-6 col-xl-6">
                    <div class="box-col box-col-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" class="align-middle text-left" width="350">
                                        {{idOportunidade}} - {{NomeTomador}}
                                    </th>
                                    <th scope="col" class="align-middle text-right">
                                        {{formatCurrency(this.reserva.Valor)}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="align-middle text-left">
                                        Total à Pagar
                                    </td>
                                    <td class="align-middle text-right">
                                        {{ValorBoleto}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card">
                        <div :class="this.ScoreClass(this.score)" class="card-img-top card-background">
                            <div class="badge badge-id">ID: {{idOportunidade}}</div>
                            <h2>{{NomeTomador}}</h2>
                            <div class="rating">
                                <span class="circle">{{score}}</span>
                            </div>
                        </div>
                        <div :class="this.ScoreClass(this.score)" class="card-body">
                            <dt>Valor Investimento</dt>
                            <dd class="value">{{formatCurrency(this.reserva.Valor)}}</dd>
                            <dd>
                                <p class="small">Total à Pagar:
                                    <strong>{{ValorBoleto}}</strong>
                                </p>
                            </dd>
                        </div>
                        <div class="card-footer d-flex justify-content-between">
                            <div class="tax">
                                <strong>Rendimento</strong>
                                <span> {{Rendimento}}% a.a</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="gray col-12 col-lg-6 col-xl-6">
                    <div class="box-col box-col-list">
                        <ul>
                            <li>
                                Dados do investidor
                            </li>
                            <li>
                                {{NomeCompleto}}
                            </li>
                            <li>
                                {{FormatedAddress}}
                            </li>
                            <li>
                                {{Cep}}
                            </li>
                            <li>
                                <router-link to="/investimentos/perfil/editar-perfil" class="">
                                    Alterar endereço do investidor
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--<div class="yallow col-12 col-xl-4">
                    <div class="box-col box-col-p">
                        <p>
                            Quando as captações chegarem em 100% do valor
                            solicitado pelo tomador, a solicitação será encerrada
                            imediatamente, e o boleto será liberado para pagamento.
                            O boleto deve ser pago em <span>24 horas</span>.
                        </p>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="col-12">
            <div class="ticket-payment">
                <div class="sec_tit text-left">
                    <h2>
                        Forma de pagamento
                        <span>
                            BOLETO BANCÁRIO
                        </span>
                    </h2>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-6 col-lg-4">
                        <p>
                            <i class="icon icon-printer-2 xl"></i>
                            Imprima o boleto e <span> pague no banco </span>
                        </p>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <p>
                            <i class="icon icon-gedgets xl"></i>
                            <span> ou pague pela internet </span> utilizando o código de barras do boleto
                        </p>
                    </div>
                    <div class="col-12 col-lg-4">
                        <p>
                            <i class="icon icon-calendar-2 xl"></i>
                            o prazo de validade do boleto é de <span> 1 dia útil </span>
                        </p>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-md-6 col-lg-3 total-value">
                        <h5>
                            Total à Pagar: {{ValorBoleto}}
                        </h5>
                    </div>
                    <div class="col-md-6 col-lg-3">

                        <a v-if="feat_abc != 'true' && this.reserva.Status == 1" :href="this.reserva.Boleto.secure_url" class="btn btn-primary btn-submit" target="_blank" :disabled="verificaBoleto()">
                            pagar boleto
                        </a>
                        <!-- <a v-else-if="this.boleto.Status == 'pending'" download="file.pdf" :href="'data:application/pdf;base64,'+boleto.PDFBinario" class="btn btn-primary btn-submit" target="_blank" :disabled="verificaBoleto()">
                            pagar boleto
                        </a> -->
                        <a v-else-if="this.boleto.Status == 'pending'" :href="boletoUrl" target="_blank" class="btn btn-primary btn-submit" :disabled="verificaBoleto()">
                            pagar boleto
                        </a>
                        <p v-if="verificaBoleto()" class="small">*Boleto pago</p>
                        
                    </div>
                    <div class="col-12 col-lg-3">
                        <p>
                            Pagamento seguro <span>IOUU</span>
                            <i class="icon icon-lock-2 md"></i>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <ul class="footer-note">
                Importante:
                <li>
                    <p>
                        <i class="fas fa-circle"></i>
                        Caso o seu computador tenha um programa anti pop-up, será preciso desativá-lo antes de finalizar seu investimento e imprimir o boleto ou pagar pelo internet banking;
                    </p>
                </li>
                <li>
                    <p>
                        <i class="fas fa-circle"></i>
                    Não faça depósito ou transferência entre contas. O boleto não é enviado pelos Correios. Imprima-o e pague-o no banco ou pela internet;
                    </p>
                </li>
                <li>
                    <p>
                        <i class="fas fa-circle"></i>
                    Se o boleto não for pago até a data de vencimento, a reserva de investimento será automaticamente cancelada;
                    </p>
                </li>
                <li>
                    <p>
                        <i class="fas fa-circle"></i>
                        A confirmação do seu investimento pago com boleto bancário começa a contar três dias depois do pagamento do boleto, tempo necessário para que a instituição bancária confirme o pagamento.
                    </p>
                </li>
            </ul>
        </div>

    </div>

    

    <div class="d-flex justify-content-center align-items-center fish-investiment" v-else-if="finshedLoadingNot">
        <div class="row">
            <div class="col-12 text-center">
                <h1>
                    Finalização de pagamento
                </h1>
            </div>
        </div>
    </div>

</template>

<script>
import * as mutationTypes from '@/store/mutation-types.js'
import reservaApi from '../services/api/reservaInvestimento';
import ApiClient from '../utils/api-client'
import Modal from '@/components/Modal'
import Masker from '../utils/masker'

	export default {
        data() {
            return {
                showModal: false,
                investor: null,
                endereco: null,
                finshedLoading: false,
                reservaId: "",
                reserva: null,
                boleto: null,
                solicitacao: null,
                finshedLoadingNot: false,
                errorLoading: false,
                score:null,
                feat_abc:process.env.FEAT_ABC,
            }
        },
        computed: {
            NomeCompleto: function() {
                return this.investor.NomeCompleto;
            },
            FormatedAddress: function() {

                if(this.endereco == undefined)
                return "";

                return `${this.endereco.Logradouro}, ${this.endereco.Numero},
                        ${this.endereco.Complemento} - ${this.endereco.Bairro} ${this.endereco.Cidade} -
                        ${this.endereco.Uf}`
            },
            Cep: function() {
                if(this.endereco == undefined)
                    return "";
                return `CEP ${this.endereco.Cep}`
            },
            ValorBoleto: function() {
                if(!this.reserva.ReInvestimento) this.reserva.ReInvestimento = 0
                return this.formatCurrency(this.reserva.Valor-this.reserva.ReInvestimento)
            },
            NomeTomador: function() {
                return this.solicitacao.Empresa.NomeFantasia
            },
            idOportunidade: function() {
                return `ID#${this.solicitacao.IdOportunidade}`;
            },
            Rendimento: function() {
                return this.solicitacao.Rendimento;
            },
            boletoUrl() {
                return `${process.env.API_PAY}/boleto/investidor/${this.boleto._id}`
            }
        },
        components: { Modal },
        methods: {
            BoletoPDF(pdf) {
                var bin = atob(pdf);
                
                // Embed the PDF into the HTML page and show it to the user
                var obj = document.createElement('object');
                obj.style.width = '100%';
                obj.style.height = '842pt';
                obj.type = 'application/pdf';
                obj.data = 'data:application/pdf;base64,' + pdf;
                document.body.appendChild(obj);
                
                // Insert a link that allows the user to download the PDF file
                var link = document.createElement('a');
                link.innerHTML = 'Download PDF file';
                link.download = 'file.pdf';
                link.href = 'data:application/octet-stream;base64,' + pdf;
                document.body.appendChild(link);
                return `rating-${score.toLowerCase()}`
            },
            ScoreClass(score) {
                // let score = this.score
                if (score == null || score == undefined) return "";
                return `rating-${score.toLowerCase()}`
            },
            Score(score) {
                if (score == null || score == undefined) return "";

				if (score == "AA" || score == "HR") return score;

				return score.substr(0, 1);
            },
            formatCurrency(value) {
                if(value != null)
                    return "R$ "+value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

                return 0;
            },
            verificaBoleto() {
                return this.reserva.StatusBoleto === "paid" ? true : false;
            },

           //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/finalizar-investimento',
                    title: 'Finalizar investimento',
                })
            }, 
        },
        async beforeCreate() {
            this.$store.commit(mutationTypes.START_LOADING);
            const reservaid = this.$route.query.id;
            localStorage.removeItem("pre_investimento")

            try {
                this.investor = await ApiClient.getInvestor();
                this.endereco = this.investor.Endereco;

                this.reserva = await ApiClient.getReservaSolicitacao(reservaid);
                let resp = await reservaApi.GetBoletoInvestidor(reservaid);
                this.boleto = resp.data
                if(this.reserva.Boleto) {
                    this.score = this.Score(this.reserva.SolicitacaoId.Score);
                    this.solicitacao = this.reserva.SolicitacaoId;
                    this.finshedLoading = true;
                } else {
                    setTimeout(async () => {
                        this.reserva = await ApiClient.getReservaSolicitacao(reservaid);
                        this.solicitacao = this.reserva.SolicitacaoId;
                        this.finshedLoading = true;
                    }, 2000);
                }

            } catch(erro) {
                this.finshedLoadingNot = true;
            }

            this.$store.commit(mutationTypes.STOP_LOADING);

        },

        async created() {
            //tagueamento GA
            await this.taggingGA();
        }
  }
</script>

<style scoped lang="scss">
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";


    .total-value{
        display: inline-flex !important;
        justify-content: center;
        align-items: center;
        
        & > h5{
            font-size:1.5em !important;
        }
    }

    .side-circle{
        width: 12px;
        height: 12px;
        display: inline-flex;
    }

    @media (max-width: 900px) {
        .btn-submit{
            margin: 10px;
            margin-left:0px;
            width: 100%;
        }
    }

    .box-col-table {
        display:block;
    }

    .card {
        display:none;
    }

    @media (max-width: 900px) {
        .box-col-table {
            display:none;
        }

        .card {
            display:block;
        }
    }

    .card-img-top {
        margin: 15px;

        .rating {
            display: flex;
            justify-content: center;
            margin-left: -15px;
            margin-top: 15px;
        }
    }

    .gray {
      @include brkp-01(1199px) {
        margin-top: 1rem;
      }
    }

    .table {
        &{
            border: none !important;
            margin: 0;
        }

        th {
            border: none !important;
        }

        tr {

            &{
                border-bottom:1px solid #e9ecef !important;
            }

            &:last-child {
                border: none !important;
            }
        }
    }

    .tit_page {
        &{
            margin-bottom: 30px;
        }

        h1 {
            font-size: calcRem(30);
        }
    }

    .sec_tit {

        &{
            margin-top: 30px;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 1px solid #dddddd;
        }

        h2 {
            font-size: calcRem(18);

            span {
                font-size: calcRem(18);
                text-transform: uppercase;
            }
        }
    }

    .footer-note {
        &{
            font-size: calcRem(15);
            color: #999999;
            font-weight: 700;
            margin-top: 30px;
        }

        p {
            &{
                font-size: calcRem(12);
                color: #999999;
                font-weight: 500;
                margin: 0;
            }

            i {
                font-size: 5px;
                display: inline-block;
                vertical-align: middle;
            }
        }
    }

    .ticket-payment {

        &{
            text-align: center;
        }

        .justify-content-center {
            margin-top: 40px;
            margin-bottom: 30px;
        }

        h5 {
            color: #02ACEF;
            font-size: calcRem(30);
            font-weight: 700;
            display: inline-block;
            vertical-align: middle;
        }

        .btn {
            &-primary {
                background-color: $btn-invest;
                font-size: calcRem(18);
                text-transform: uppercase;
                border: none;
                font-weight: 700;
                padding: calcRem(10) calcRem(50);
                display: inline-block;
                vertical-align: middle;

                &[disabled] {
                  background-color: #ccc !important;
                  color: #fff !important;
                }

                &:hover {
                    background: darken($btn-invest, 5%);
                }
            }
        }

        p {
            &{
                display: inline-block;
                text-align: center;
                vertical-align: middle;
                width: 70%;
                font-size: 1rem;
                margin-bottom: 0;
                margin-left: 5px;
                color: #000;
            }

            i {
                margin-right: 5px;
            }

            span {
                font-weight: 700;
            }

            &.small {
              font-size: 0.7rem;
            }
        }
    }

    .box-col {
        &{
            border: 1px solid #dddddd;
            border-radius: 5px;
            padding: 15px 30px;
            min-height: 200px;
        }

        .table {

            th {
                color: #666;

                a {
                    color: #02ACEF;
                    margin-left: 5px;
                }
            }

            td {
                color: #02ACEF;
                font-weight: 700;
            }
        }

        ul {
            li {

                &{
                    color: #777777;
                }

                &:first-child {
                    font-weight: 700;
                    font-size: calcRem(20);
                }

                &:nth-child(2) {
                    text-transform: uppercase;
                }

                &:last-child {
                    a {
                        font-size: calcRem(14);
                        color: #777777;
                        text-decoration: underline !important;
                    }
                }
            }
        }

        &-table {
            padding-left: 10px;
            padding-right: 10px;
        }

        &-list {
            background-color: #f7f7f7;
        }

        &-p {
            &{
                padding: 30px 50px;
                border-color: #FFEEBA;
                background-color: #FFF3CD;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;


                @include brkp-01(1500px) {
                    min-height: inherit;
                    margin-top: 1rem;
                }
            }

            p {
                color: #856404;

                span {
                    font-weight: 700;
                }
            }
        }
    }

    .modal-header {
        .tit_page {
            margin-bottom: 0;
        }

        div {
            width: 100%;
        }

        h2 {
            color: #434371;
            font-size: calcRem(30);
        }

        hr {
            margin-bottom: 0;
        }
    }

    .modal-body {
        .bordered {
            &{
                border: 1px solid #DDDDDD;
                padding: 20px;
                border-radius: 5px;
            }

            .table {

                th {
                    font-weight: 700;
                }

                td {
                    &{
                        color: #666;
                    }

                    span {
                        &:not(.box){
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                }

                .rating {
                    span {
                        width: 20px;
                        height: 20px;
                        display: inline-block;
                        vertical-align: middle;
                    }
                }
            }
        }

        .td-total {
            &{
                padding: 0 20px;
                margin-top: 20px;
                margin-right: 20px;
                background-color: #EEEEEE;
                border-radius: 5px;
            }

            .table {
                &{}

                th {
                    &{
                        color: #666666;
                        font-size: calcRem(18);
                        font-weight: 400;
                         padding-top: 20px;
                    }
                }

                tr {
                    &{
                        border-bottom:1px solid #dddddd !important;
                    }
                }

                td {
                    &{
                        color: #02ACEF;
                        font-size: calcRem(30);
                        font-weight: 700;
                        padding-bottom: 20px;
                        border-top: 1px solid #dddddd;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/FinishInvestment.vue